module.exports = __webpack_public_path__ + "img/187-vanuatu.f25d8a36.svg";